/* eslint-disable linebreak-style */
/* eslint-disable import/prefer-default-export */

function lang() {
  try {
    const { direction } = JSON.parse(localStorage.getItem('settings'));
    return direction === 'ltr' ? 'en' : 'ar';
  } catch { }
  // return "en";
}

// Note every attribute is array of two items 0> English , 1> Arabic
const DICTIONARY = {
  login_title: ["Login", "تسجيل الدخول"],
  new: ["New", "جديد"],
  save: ["Save", "حفظ"],
  view_edit: ["View or Edit record", "عرض / تعديل السجل"],
  save_new: ["Save And New", "حفظ و جديد"],
  save_copy: ["Save And Copy", "حفظ ونسخ"],
  save_print: ["Save And Print", "حفظ وطباعة"],
  print: ["Print", "طباعة"],
  clear: ["Clear", "مسح"],
  copy: ["Copy", "نسخ"],
  delete: ["Delete", "حذف"],
  cancel: ["Cancel", "إلغاء"],
  attachments: ["Attachments", "المرفقات"],
  retrive: ["Retrive", "استرجاع"],
  post: ["Post", "ترحيل"],
  alert: ["Alert !", "تنبيه !"],
  warning: ["Warning!", "تحذير!"],
  no: ["No", "لا"],
  yes: ["Yes", "نعم"],
  alert_leave: ["Are You Sure you want to Leave?", "هل أنت متأكد من المغادرة؟"],
  exit: ["Exit", "خروج"],
  update: ["Update", "تعديل"],
  dashboard: ["Dashboard", "لوحة التحكم"],
  pages: ["Pages", "الصفحات"],
  not_found: ["Not found", "غير موجود"],
  please_select_company_and_branch: [
    "Please select company and branch",
    "يرجى اختيار الشركة والفرع"
  ],
  lose_unsaved_data_leave: [
    "You will lose unsaved data. Are you sure you want to leave?",
    "ستفقد البيانات غير المحفوظة. هل أنت متأكد أنك تريد المغادرة؟"
  ],
  lose_unsaved_data_new_record: [
    "You will lose unsaved data. Are you sure you want to create a new record?",
    "ستفقد البيانات غير المحفوظة. هل أنت متأكد أنك تريد إنشاء سجل جديد؟"
  ],
  confirm_delete: ["Confirm delete", "تأكيد الحذف"],
  delete_record_cannot_undo: [
    "Are you sure you want to delete this record? This action cannot be undone.",
    "هل أنت متأكد أنك تريد حذف هذا السجل؟ لا يمكن التراجع عن هذا الإجراء."
  ],

  save_done: ["Data Saved successfully.", "تم الحفظ بنجاح."],
  delete_done: ["Record Deleted successfully.", "تم الحذف بنجاح."],
  please_wait: ["Please wait until finish.", "يرجى الانتظار حتى الانتهاء."],
  invalid_date: ["Invalid Date", "تاريخ غير صحيح"],
  more_options: ["More options", "خيارات إضافية"],
  filter: ["Filter", "البحث"],
  apply_filter: ["Apply filter", "تطبيق البحث"],
  clear_filter: ["Clear Filters", "حذف معاملات البحث"],
  filter_data: ["Filter Data", "تصفية البيانات"],
  address_information: ["Address Information", "معلومات العنوان"],
  contact_information: ["Contact Information", "معلومات الاتصال"],
  financial_information: ["Financial Information", "المعلومات المالية"],
  view_report: ["View Report", "عرض التقرير"],
  add_row: ["Add Row", "إضافة سطر"],
  click_add_new_row: ["Click here to add new row", "اضغط هنا لإضافة سطر جديد"],
  edit_record: ["Edit record", "تعديل السجل"],
  add_new_record: ["Add new record", "إضافة سجل جديد"],
  submit_and_new: ["Submit And New", "تأكيد وجديد"],
  system_error_try_later: [
    "System error, please try again later.",
    "خطأ في النظام، يرجى المحاولة لاحقاً."
  ],
  total_credit_must_equal_total_debit: [
    "Total credit must be equal to the Total debit.",
    "يجب أن يكون إجمالي الدائن مساوياً لإجمالي المدين."
  ],
  quantity_more_than_zero: [
    "Quantity must be more than Zero.",
    "يجب أن تكون الكمية أكبر من صفر."
  ],
  price_more_or_equal_zero: [
    "Price must be more than or equal to Zero.",
    "يجب أن يكون السعر أكبر من أو يساوي صفر."
  ],
  amount_more_than_zero: [
    "Amount must be more than Zero.",
    "يجب أن يكون المبلغ أكبر من صفر."
  ],
  expense_type_required: ["Expense Type is required.", "نوع المصروف مطلوب."],
  enter_credit_or_debit: [
    "You must enter Credit or Debit Value.",
    "يجب إدخال قيمة دائن أو مدين."
  ],
  cant_enter_credit_and_debit_same_time: [
    "You can't enter Credit and Debit Value at the same time.",
    "لا يمكنك إدخال قيمة الدائن والمدين في نفس الوقت."
  ],
  error_in_ledger: ["Error in ledger.", "خطأ في دفتر الأستاذ."],
  subledger_a_required: ["Sub-ledger A is required.", "الدفتر الفرعي A مطلوب."],
  subledger_b_required: ["Sub-ledger B is required.", "الدفتر الفرعي B مطلوب."],
  subledger_c_required: ["Sub-ledger C is required.", "الدفتر الفرعي C مطلوب."],
  subledger_d_required: ["Sub-ledger D is required.", "الدفتر الفرعي D مطلوب."],

  attachments_title: ["Form Attachments", "المرفقات"],
  back: ["Back", "رجوع"],
  close: ["Close", "إغلاق"],
  reload: ["Reload", "تحديث"],
  submit: ["Submit", "تأكيد"],
  select: ["Select", "اختر"],
  select_file: ["Select File", "اختر ملف/ملفات"],
  clear_all: ["Clear All", "حذف الكل"],
  download_file: ["Download File", "تحميل الملف"],
  remove_item: ["Remove Item", "حذف الملف"],
  browse: ["Browse", "تصفح"],
  select_file_desc1: [
    "Drop files here or click",
    " قم بإسقاط الملفات هنا أو اضغط على ",
  ],
  select_file_desc2: ["thorough your machine", " ملفات جهازك"],

  //matrial-table
  no_records: ["No records to display", "لا توجد بيانات"],
  actions: ["#", "#"],
  add: ["Add", "إضافة"],
  edit: ["Edit", "تعديل"],
  delete_text: ["Are you sure delete this row?", "هل أنت متأكد من حذف السجل؟"],
  place_holder: ["Drag headers ...", "اسحب رؤوس الأعمدة للتجميع بها..."],
  grouped_by: ["Grouped By:", "مجمعة حسب:"],
  of: ["of", "من"],
  rows: ["rows", "سجل"],
  first_page: ["First Page", "الصفحة الأولى"],
  previous_page: ["Previous Page", "الصفحة السابقة"],
  next_page: ["Next Page", "الصفحة التالية"],
  last_page: ["Last Page", "الصفحة الأخيرة"],
  rows_selected: ["{0} row(s) selected", "{0} سجل محدد"],
  show_columns_title: ["Show Columns", "عرض/اخفاء الأعمدة"],
  search: ["Search", "بحث"],
  export: ["Export", "تصدير"],
  export_csv: ["ُExport as CSV", "تصدير CSV"],
  import_from_excel: ["Import from Excel File", "استيراد من ملف اكسل"],
  authorization_error: ["Authorization error.", "خطأ في التفويض."],
  unexpected_error_occurred: [
    "An unexpected error occurred.",
    "حدث خطأ غير متوقع."
  ],
  auto_hide_menu: ["Auto Hide Menu", "إخفاء القائمة تلقائياً"],
  always_show_menu: ["Always show Menu", "إظهار القائمة دائماً"],
  account: ["Account", "الحساب"],
  profile: ["Profile", "الملف الشخصي"],
  sign_out: ["Sign out", "تسجيل الخروج"],
  notifications: ["Notifications", "الإشعارات"],
  new_notifications: ["New Notifications", "إشعارات جديدة"],
  show_all_notifications: ["Show all notifications", "عرض كل الإشعارات"],
  messages: ["Messages", "الرسائل"],
  new_messages: ["New Messages", "رسائل جديدة"],
  show_all_messages: ["Show all messages", "عرض كل الرسائل"],
  languages: ["Languages", "اللغات"],
  click_change_company: ["Click to change company", "اضغط لتغيير الشركة"],
  click_change_branch: ["Click to change branch", "اضغط لتغيير الفرع"],
  select_company: ["Select Company", "اختر الشركة"],
  select_branch: ["Select Branch", "اختر الفرع"],
  change_company_reload_warning: [
    "Changing company will reload page, and you will lose unsaved data. Are you sure you want to change company?",
    "تغيير الشركة سيعيد تحميل الصفحة، وستفقد البيانات غير المحفوظة. هل أنت متأكد أنك تريد تغيير الشركة؟"
  ],
  select_demo: ["Select a demo", "اختر نموذجاً"],
  hello: ["Hello!", "مرحباً!"],
  select_style_below: [
    "Select your style below. Choose the one that best fits your needs.",
    "اختر النمط أدناه. اختر ما يناسب احتياجك بشكل أفضل."
  ],
  dark: ["Dark", "داكن"],
  light: ["Light", "فاتح"],
  default: ["Default", "افتراضي"],
  blue: ["Blue", "أزرق"],
  green: ["Green", "أخضر"],
  indigo: ["Indigo", "نيلي"],
};

export function getCaption(key) {
  const index = lang() === "en" ? 0 : 1;
  let ret;
  try {
    ret = DICTIONARY[key.toLowerCase()][index];
  } catch (error) {
    ret = key;
  }
  return ret;
}
